import React, { Component } from 'react';
import Shimmer from 'sushiweb/Shimmer';
import { Modal, Tooltip } from '../../../UiKit';
import { MoreOrderedItems } from '../../popups';
import './ItemsOrdered.scss';
import { upArrowIconGreen } from '../../../images/images';

export default class ItemsOrdered extends Component {
  render() {
    const { items } = this.props;
    return (
      <div className='itemsOrderedContainer'>
        {!items ? (
          <Shimmer height='150px' width='100%' />
        ) : (
          <ItemsOrderedComp {...this.props} />
        )}
      </div>
    );
  }
}

class ItemsOrderedComp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showMoreItems: false,
    };
  }

  showMoreItems = () => {
    this.setState({
      showMoreItems: true,
    });
  };

  renderItemsList = (items) => {
    const orderedItems = Object.keys(items);
    const orderedItemsList = orderedItems.slice(0, 2);
    orderedItems.splice(0, 2);
    return (
      <>
        {orderedItemsList.map((item, index) => {
          return (
            <React.Fragment key={index}>
              <li>
                <p>
                  {items[item].quantity} x {items[item].name}
                  {items[item].product_url ? (
                    <Tooltip
                      position='bottom'
                      border={false}
                      title={
                        <>
                          <a
                            target={'_blank'}
                            href={items[item].product_url}
                            className='iconMarginL icon'
                            rel='noreferrer'
                          >
                            <img
                              src={upArrowIconGreen}
                              alt='open link in product details'
                            />
                          </a>
                        </>
                      }
                      label={items[item].product_url_tooltip}
                    />
                  ) : null}
                </p>
              </li>
            </React.Fragment>
          );
        })}
        {orderedItems.length ? (
          <li>
            <p className='dark moreOrderedItems'>
              <span
                className='greenBottomBorder'
                onClick={this.showMoreItems.bind(this)}
              >
                + {orderedItems.length} more items
              </span>
            </p>
          </li>
        ) : null}
      </>
    );
  };

  hideMoreItems = () => {
    this.setState({
      showMoreItems: false,
    });
  };

  render() {
    const { items, isRequested } = this.props;
    const { showMoreItems } = this.state;
    const orderedItems = Object.keys(items);
    if (!orderedItems) return null;

    return (
      <div className='orderedItemsBox col'>
        <p className='orderedItemsHeader dark large'>
          {isRequested ? 'Requested Items' : 'Items ordered'}
        </p>
        <div className='itemsList pt10'>
          <ul>{this.renderItemsList(items)}</ul>
        </div>
        <Modal
          isVisible={showMoreItems}
          title={isRequested ? 'Requested Items' : 'Items ordered'}
          handleClose={this.hideMoreItems.bind(this)}
          component={<MoreOrderedItems items={items} />}
        />
      </div>
    );
  }
}
